import { Contract } from "@ethersproject/contracts";

export const getContract = (library, account, abi, contractAddress) => {
    const signer = library.getSigner(account).connectUnchecked();
    return new Contract(contractAddress, abi.abi, signer);
};
